<template>
    <div>
        <div class="shrink-0 grow basis-auto px-5 sm:px-10">
            <div class="mx-auto max-w-240 sm:w-auto">
                <div class="">
                    <div class="text-center pt-4 cm-footer-box" data-testid="simple-footer-layout">
                        <div class="align-middle text-lg text-footer-color">
                            <a href="https://www.webplanex.com/" target="_blank">
                                <img src="https://www.webplanex.com/wp-content/uploads/2023/02/webplanex-logo-new.png"
                                    style="height: auto; width: 90px;">
                            </a>
                        </div>
                        <div class="mt-10" data-testid="simple-footer-links">
                            <div class="align-items-center d-flex justify-content-center pt-3 text-center">

                                <a class="-undash facebook m-1 p-2" href="https://www.facebook.com/WebPlanexPVTLTD"
                                    target="_blank" rel="nofollow noopener">
                                    <i class="fab fa-facebook-f"></i> </a>

                                <a class="-undash twitter m-1 p-2" href="https://twitter.com/webplanex" target="_blank"
                                    rel="nofollow noopener"> <i class="fab fa-twitter"></i> </a>
                                <a class="-undash linkedin m-1 p-2" href="https://www.linkedin.com/company/webplanex"
                                    target="_blank" rel="nofollow noopener"> <i class="fab fa-linkedin"></i> </a>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></link>
</script>
<script>
export default {
    name: "Footer",
}
</script>

